var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"kiosks"},[(_vm.no_kiosk)?_c('h1',[_vm._v("Invalid Kiosk Slug")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }